import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        create: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('payments', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        getBanks: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('banks', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        getBeneficiaries: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('beneficiaries', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        getCurrencies: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('currencies', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        show: (cntx, { id }) => {
            axios.get(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        update: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`banks/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        remove: (cntx, id) => {
            return new Promise((resolve, reject) => {
                axios.delete(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}
